import { IBusinessTrainingCentre } from 'src/app/shared/types/business-models';
import { FirestoreService } from 'src/app/services/firestore.service';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BusinessTrainingService {
  businessTrainings: BehaviorSubject<any> = new BehaviorSubject<IBusinessTrainingCentre[]>(null);
  businessTrainingsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );

  constructor(private firestore: AngularFirestore, private firestoreService : FirestoreService) {}

  loadBusinessTrainings() {
    this.businessTrainingsLoading.next(true);
    this.loadDatas().subscribe(
      (res) => {
        console.log('Loaded businessTrainings', res);
        this.businessTrainings.next(res);
        this.businessTrainingsLoading.next(false);
      },
      (err) => {
        console.log(err);

        this.businessTrainings.next(null);
        this.businessTrainingsLoading.next(false);
      }
    );
  }

  loadDatas() {
    return this.firestore
      .collection(this.firestoreService.BANNERS_COLLECTION, (ref) =>
        ref.where('status', '==', 'active').orderBy('addedDate', 'desc')
      )
      .snapshotChanges()
      .pipe(
        map((actions) =>
          actions.map((a) => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          })
        )
      );
  }
}
